<template>
  <div class="help-request-wrapper">
    <div class="help-request-btn-row">
      <base-button
        variant="primary"
        @click="toggleHelpDropdown"
        :disabled="lead.practicalHelp.WantPracticalHelpFake"
        class="help-request-btn"
      >
        {{ lead.practicalHelp.WantPracticalHelpFake ? 'Hulp aangevraagd' : 'Hulp nodig?' }}
      </base-button>
      <transition name="fade-in">
        <div v-if="showHelpDropdown" class="help-dropdown" ref="dropdown">
          <div class="help-dropdown-text-area">
            <button class="help-dropdown-close" @click="closeDropdown" aria-label="Sluiten">
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="small mb-2 help-dropdown-text">Heeft u hulp nodig bij het invullen<br>of wilt u dat wij contact opnemen?</div>
          </div>
          <div class="help-dropdown-btn-row">
            <base-button variant="warning" size="sm" @click="confirmHelp">Vraag nu hulp aan</base-button>
          </div>
        </div>
      </transition>
    </div>
    <transition name="fade-in">
      <div v-if="showHelpModal" class="help-modal-overlay">
        <div class="help-modal-content">
          <h4>Hulp aangevraagd</h4>
          <p>We nemen binnen 7 werkdagen contact met u op.<br>U kunt deze pagina nu afsluiten.</p>
          <base-button variant="primary" @click="closeHelpModal">Oke</base-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';
import { useAllStores } from "@/helpers/UseAllStores";
import { LeadDataService } from '@/services/LeadDataService';

export default {
  name: 'HelpRequestButton',
  components: { BaseButton },
  setup() {
    return { ...useAllStores() };
  },
  data() {
    return {
      showHelpDropdown: false,
      showHelpModal: false,
    };
  },
  methods: {
    toggleHelpDropdown() {
      this.showHelpDropdown = !this.showHelpDropdown;
      if (this.showHelpDropdown) {
        this.$nextTick(() => {
          document.addEventListener('mousedown', this.handleClickOutside);
        });
      } else {
        document.removeEventListener('mousedown', this.handleClickOutside);
      }
    },
    async confirmHelp() {
      this.showHelpModal = true;
      this.showHelpDropdown = false;
      document.removeEventListener('mousedown', this.handleClickOutside);
      if (this.lead && typeof this.lead.setPracticalHelpRequested === 'function') {
        this.lead.setPracticalHelpRequested(true);
        try {
          if (this.uiStore && this.uiStore.uuid) {
            await LeadDataService.pushRemoteData(this.uiStore.uuid, false);
          }
        } catch (e) {
          console.warn('Hulpaanvraag niet direct opgeslagen:', e);
        }
      }
    },
    closeHelpModal() {
      this.showHelpModal = false;
    },
    closeDropdown() {
      this.showHelpDropdown = false;
      document.removeEventListener('mousedown', this.handleClickOutside);
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.dropdown;
      if (dropdown && !dropdown.contains(event.target)) {
        this.closeDropdown();
      }
    }
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
};
</script>

<style scoped lang="scss">
.help-request-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1rem;
}
.help-request-btn-row {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.help-request-btn {
  margin-bottom: 0.5rem;
}
.help-dropdown {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.12);
  padding: 1rem 1.2rem 1rem 1.2rem;
  min-width: 220px;
  max-width: 340px;
  z-index: 201;
  text-align: left;
  margin-top: 0.5rem;
  position: absolute;
  left: 0;
}
.help-dropdown-text-area {
  position: relative;
  padding-right: 2em;
}
.help-dropdown-close {
  position: absolute;
  top: 0.2em;
  right: 0.2em;
  background: none;
  border: none;
  font-size: 1.4em;
  color: #888;
  cursor: pointer;
  z-index: 202;
  padding: 0;
  line-height: 1;
}
.help-dropdown-close {
  position: absolute;
  top: 8px;
  right: 12px;
  background: none;
  border: none;
  font-size: 1.4em;
  color: #888;
  cursor: pointer;
  z-index: 202;
  padding: 0;
  line-height: 1;
}
.help-dropdown-text {
  word-break: break-word;
  white-space: normal;
}
.help-dropdown-btn-row {
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
}
.help-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.3);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.help-modal-content {
  background: #fff;
  border-radius: 12px;
  padding: 2rem 2.5rem;
  box-shadow: 0 2px 24px rgba(0,0,0,0.15);
  text-align: center;
  min-width: 320px;
  max-width: 90vw;
}
@media (max-width: 600px) {
  .help-request-wrapper {
    align-items: stretch;
  }
  .help-request-btn-row {
    align-items: stretch;
  }
  .help-request-btn {
    margin-left: 12px;
    margin-right: 12px;
    width: calc(100vw - 24px);
    box-sizing: border-box;
  }
  .help-dropdown {
    position: static;
    min-width: 0;
    max-width: calc(100vw - 24px);
    margin-left: 12px;
    margin-right: 12px;
    padding: 1rem 0.8rem;
    box-sizing: border-box;
  }
  .help-dropdown-text-area {
    padding-right: 2em;
    position: relative;
  }
  .help-dropdown-close {
    top: 0.2em;
    right: 0.2em;
    position: absolute;
  }
  .help-dropdown-btn-row {
    justify-content: center;
  }
  .help-modal-content {
    min-width: 90vw;
    padding: 1rem;
  }
}
</style>
